
export const calculatePensionsCost = (_age, _target_retirement_age, _gross_monthly_income, _regular_premium, _existing_pension_pot) => {

    // cap factors
    var cap_factors = new Array();
    cap_factors[50] = 45.5291;
    cap_factors[51] = 44.3397;
    cap_factors[52] = 43.1583;
    cap_factors[53] = 41.9853;
    cap_factors[54] = 40.8214;
    cap_factors[55] = 39.6667;
    cap_factors[56] = 38.5217;
    cap_factors[57] = 37.3864;
    cap_factors[58] = 36.2615;
    cap_factors[59] = 35.1470;
    cap_factors[60] = 34.0432;
    cap_factors[61] = 32.9503;
    cap_factors[62] = 31.8684;
    cap_factors[63] = 30.7979;
    cap_factors[64] = 29.7389;
    cap_factors[65] = 28.6915;
    cap_factors[66] = 27.6556;
    cap_factors[67] = 26.6317;
    cap_factors[68] = 25.6206;
    cap_factors[69] = 24.6240;
    cap_factors[70] = 23.6427;
    cap_factors[71] = 22.6772;
    cap_factors[72] = 21.7282;
    cap_factors[73] = 20.7961;
    cap_factors[74] = 19.8819;
    cap_factors[75] = 18.9853;


    // assumptions
    var annual_management_charge = 0.01;
    var growth = 0.046;
    var cpi_assumption = 0.03;
    var state_pension_per_week = 277.30;
    var allocation_rate = 0.95;
    var mortality_improvement = 0.0033;


    // inputs
    var regular_premium = _regular_premium;
    var existing_pension_pot = _existing_pension_pot
    if (regular_premium == 0) regular_premium = 1;
    var current_date = new Date();
    var age = _age;

    //convert current_date to excel date number
    var dob_excel_date = Math.floor(25569.0 + ((current_date.getTime() - (current_date.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24))) -age*365.25;

    //convert excel_date serial date to javascript date
    function ExcelDateToJSDate(serial) {
        var utc_days  = Math.floor(serial - 25569);
        var utc_value = utc_days * 86400;
        var date_info = new Date(utc_value * 1000);

        var fractional_day = serial - Math.floor(serial) + 0.0000001;
        var total_seconds = Math.floor(86400 * fractional_day);
        var seconds = total_seconds % 60;
        total_seconds -= seconds;
        var hours = Math.floor(total_seconds / (60 * 60));
        var minutes = Math.floor(total_seconds / 60) % 60;
        return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
    }


    var date_of_birth = new Date();
    date_of_birth = ExcelDateToJSDate(dob_excel_date);

    var normal_retirement_age = _target_retirement_age;
    var normal_retirement_date = new Date(date_of_birth.getFullYear() + normal_retirement_age, date_of_birth.getMonth() + (date_of_birth.getDate() == 1 ? 0 : 1), 1);
    var start_date = new Date(current_date.getFullYear(), current_date.getMonth(), 1);
    var term_in_months = (normal_retirement_date.getFullYear() - start_date.getFullYear() - (normal_retirement_date.getMonth() < start_date.getMonth() ? 1 : 0)) * 12 + (start_date.getMonth() <= normal_retirement_date.getMonth() ? normal_retirement_date.getMonth() - start_date.getMonth() : 12 + normal_retirement_date.getMonth() - start_date.getMonth()) - 6;

    var maximum_pension_fund = 2000000 * Math.pow((1 + cpi_assumption), (term_in_months / 12));

    if (date_of_birth.getFullYear() <= 1954) var state_pension_age = 66;
    else if (date_of_birth.getFullYear() <= 1960) state_pension_age = 67;
    else state_pension_age = 68;
    var gross_monthly_income = _gross_monthly_income;

    // calculations

    var cap_factor = cap_factors[normal_retirement_age] * Math.pow((1 + mortality_improvement), (normal_retirement_date.getFullYear() - 2018));
    var monthly_income_needed = Math.max(gross_monthly_income - state_pension_per_week * 52.18 / 12, 0) * Math.pow((1 + cpi_assumption), (term_in_months / 12));
    if (normal_retirement_age < state_pension_age) {
        var bridging_pension = state_pension_per_week * 52.18 * Math.pow((1 + cpi_assumption), (Math.floor(term_in_months / 12) + 1)) * ((1 - Math.pow((1 + cpi_assumption), (state_pension_age - normal_retirement_age))) / -cpi_assumption); // potential source of errors
        //((1-(1+C5)^(state_pension_age-NRA))/-C5)
        //((1-Math.pow((1+cpi_assumption),(state_pension_age-normal_retirement_age)))/-cpi_assumption)
    } else {
        bridging_pension = 0;
    }
    var existing_pension_pot_rolled_up_to_retirement = (existing_pension_pot * (Math.pow((1 + growth), (term_in_months / 12)))) * Math.pow((1 - (annual_management_charge / 12)), term_in_months)

    var fund_value_needed = Math.min(monthly_income_needed * 12 * cap_factor + bridging_pension - existing_pension_pot_rolled_up_to_retirement, maximum_pension_fund);

    var roll_up = Math.min(regular_premium * allocation_rate * (((1 - 1 / (1 + growth - annual_management_charge)) / ((Math.pow((1 + growth - annual_management_charge), (1 / 12)) - 1) * 12) * Math.pow((1 + growth - annual_management_charge), (1 / 12))) * 12 * (1 - Math.pow((1 + cpi_assumption), (Math.floor(term_in_months / 12))) * Math.pow((1 + growth - annual_management_charge), (-Math.floor(term_in_months / 12)))) / (growth - annual_management_charge - cpi_assumption) * Math.pow((1 + growth - annual_management_charge), (term_in_months / 12 + 1)) + ((Math.pow((1 + cpi_assumption), Math.floor(term_in_months / 12)) * Math.pow((1 + growth - annual_management_charge), (1 / 12))) * (1 - Math.pow((1 + growth - annual_management_charge), ((term_in_months % 12) / 12))) / (1 - Math.pow((1 + growth - annual_management_charge), (1 / 12))))), maximum_pension_fund);
    var premium_needed = fund_value_needed / roll_up * regular_premium;

    var monthly_income_including_state_pension = Math.max((((roll_up - bridging_pension) / cap_factor) / 12) / Math.pow((1 + cpi_assumption), (term_in_months / 12)) + (state_pension_per_week * 52.18 / 12), 1200);
    var monthly_income_from_existing_pension_pot = (((existing_pension_pot_rolled_up_to_retirement) / cap_factor) / 12) / Math.pow((1 + cpi_assumption), term_in_months / 12);
    var monthly_income_including_state_pension_and_existing_pension_pot = Math.max((((roll_up - bridging_pension + existing_pension_pot_rolled_up_to_retirement) / cap_factor) / 12) / Math.pow((1 + cpi_assumption), (term_in_months / 12)) + (state_pension_per_week * 52.18 / 12), 1200);


    var max_premium = Math.min(10000, (maximum_pension_fund - existing_pension_pot_rolled_up_to_retirement) / (allocation_rate * (((1 - 1 / (1 + growth - annual_management_charge)) / ((Math.pow((1 + growth - annual_management_charge), (1 / 12)) - 1) * 12) * Math.pow((1 + growth - annual_management_charge), (1 / 12))) * 12 * (1 - Math.pow((1 + cpi_assumption), (Math.floor(term_in_months / 12))) * Math.pow((1 + growth - annual_management_charge), (-Math.floor(term_in_months / 12)))) / (growth - annual_management_charge - cpi_assumption) * Math.pow((1 + growth - annual_management_charge), (term_in_months / 12 + 1)) + ((Math.pow((1 + cpi_assumption), Math.floor(term_in_months / 12)) * Math.pow((1 + growth - annual_management_charge), (1 / 12))) * (1 - Math.pow((1 + growth - annual_management_charge), ((term_in_months % 12) / 12))) / (1 - Math.pow((1 + growth - annual_management_charge), (1 / 12)))))));

    /*
    if (!(_regular_premium >= 0 && _regular_premium <= max_premium)) {
      alert ("Monthly Contribution exceeds permitted limits.");
      return null;
    }
    */

    var max_monthly_income = Math.min(5000, (maximum_pension_fund - bridging_pension) / (cap_factor * 12) * Math.pow((1 + cpi_assumption), (-term_in_months / 12)) + state_pension_per_week * 52.18 / 12);

    /*
    if (!(_gross_monthly_income >= 0 && _gross_monthly_income <= max_monthly_income)) {
      alert ("Monthly Income exceeds permitted limits.");
      return null;
    }
    */

    //$('#debug').html(cap_factor + "<br />");
    //$('#debug').html(monthly_income_needed + "<br />");
    //$('#debug').html(bridging_pension + "<br />");

    //MIN(regular_premium*allocation_rate*(((1-1/(1+growth-annual_management_charge))/(((1+growth-annual_management_charge)^(1/12)-1)*12)*((1+growth-annual_management_charge)^(1/12)))*12*(1-((1+C5)^(INT(term_in_months/12)))*((1+growth-annual_management_charge)^(-INT(term_in_months/12))))/(growth-annual_management_charge-C5)*(1+growth-annual_management_charge)^(term_in_months/12+1)+((((1+C5)^INT(term_in_months/12))*(1+growth-annual_management_charge)^(1/12))*(1-(1+growth-annual_management_charge)^(MOD(term_in_months;12)/12))/(1-(1+growth-annual_management_charge)^(1/12))));maximum_pension_fund)
    //MIN(prem*ALC*(((1-1/(1+growth-amc))/(((1+growth-amc)^(1/12)-1)*12)*((1+growth-amc)^(1/12)))*12*(1-((1+C5)^(INT(term/12)))*((1+growth-amc)^(-INT(term/12))))/(growth-amc-C5)*(1+growth-amc)^(term/12+1)+((((1+C5)^INT(term/12))*(1+growth-amc)^(1/12))*(1-(1+growth-amc)^(MOD(term;12)/12))/(1-(1+growth-amc)^(1/12))));C7)
    //monthly_income_including_state_pension =(((ActualFundValue-bridge)/CapFactor)/12)/(1+C5)^(term/12)+(state_pension*52,18/12)


    //premium_needed = premium_needed - (premium_needed % 20);
    //monthly_income_including_state_pension = monthly_income_including_state_pension - (monthly_income_including_state_pension % 20);
    //max_premium = max_premium - (max_premium % 20);
    //max_monthly_income = max_monthly_income - (max_monthly_income % 20);



    var tax_relief = 0.6;

    let results = {
        premium_needed: Math.round(premium_needed),
        monthly_income_including_state_pension: Math.round(monthly_income_including_state_pension_and_existing_pension_pot),
        max_premium: Math.round(max_premium),
        max_monthly_income: Math.round(max_monthly_income)
    }
    results.tax_relief = Math.round(results.premium_needed * tax_relief);
    results.how_much = _gross_monthly_income


    return results;

}
